import { NAVIGATION_KEYS_CODES } from '../constants/keyboard';

export function onKeyDown(e: React.KeyboardEvent<HTMLInputElement>) {
  if (!e.key.match(/\d/) && !NAVIGATION_KEYS_CODES.includes(e.key)) {
    e.preventDefault();
  }
}
